import { createFileRoute } from '@tanstack/react-router'
import { APP_NAME } from '@/lib/utils'
import TokenPage from '@/features/api-settings/components/api-keys'

export const Route = createFileRoute('/_authenticated/api-settings/keys')({
  component: TokenPage,
  head: () => ({
    meta: [
      {
        title: `${APP_NAME} | Paramètres`,
      },
    ],
  }),
})
